<template>
  <div class="doanload" @click="handerDownload">
    <slot></slot>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'DownLoad',
  props: ['tdata', 'filename'],

  data() {
    return {
      list: [],
    };
  },
  methods: {
    handerDownload() {
      let blob = new Blob([this.tdata], { type: 'application/vnd.ms-excel' });
      let alink = document.createElement('a');
      alink.href = URL.createObjectURL(blob);
      alink.download =
        moment(new Date().getTime()).format('YYYYMMDDHHmmss') +
        this.filename +
        '.xls';
      alink.click();
    },
  },
};
</script>

<style lang="scss">
.doanload {
  cursor: pointer;
}
</style>
